import { getDocs, query, where,  } from "firebase/firestore";
import { AlbumsRef } from "../../../../firebase";
import { getSingleUser } from "../../../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";

export const getAllGAAlbums = async () => {
  try {
    return await getDocs(AlbumsRef);
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getFilterAlbums = async (
  dateRange,
  statusFilterOptions,
  setLoading,
  handleFilterModalClose
) => {
  setLoading(true);

  // Create a function to deduplicate documents based on their IDs
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    console.log("arr:", arr);
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    console.log("results:", uniqueDocs);
    handleFilterModalClose();
    return uniqueDocs;
  };

  try {
    let results = [];

    const statusOptions =
      statusFilterOptions.length > 0 ? statusFilterOptions : [null];

    for (const status of statusOptions) {
      let queries = [];

      if (status !== null) {
        queries.push(where("privacy", "==", status.toLowerCase()));
      }

      if (dateRange && dateRange.startDate && dateRange.endDate) {
        queries.push(where("createdAt", ">=", dateRange.startDate));
        queries.push(where("createdAt", "<=", dateRange.endDate));
      }

      if (queries.length > 0) {
        const q = query(AlbumsRef, ...queries);
        const querySnapshot = await getDocs(q);

        const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
          const userTemp = await getSingleUser(doc.data().user);
          return {
            id: doc.id,
            ...doc.data(),
            quicktaleData: [],
            userData: userTemp?.data() ? userTemp.data() : {},
          };
        });

        // Wait for all enrichment promises to resolve
        const queryResults = await Promise.all(fetchDetailsPromises);
        results = results.concat(queryResults);
      }
    }

    // Deduplicate the results
    const uniqueResults = deduplicate(results);
    console.log("uniqueResults", uniqueResults);
    handleFilterModalClose();
    return uniqueResults;
  } catch (error) {
    console.error("Error filtering Albums:", error);
    return []; // Return an empty array in case of error
  } finally {
    setLoading(false);
  }
};
